/** @jsxImportSource @emotion/react */
import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import NotificationContext from 'contexts/notificationContext';
import PropTypes from 'prop-types';
import {
  Modal,
  Button,
  ShortText,
} from 'components/common';
import api from 'api';
import confirmationImage from 'assets/companies/confirmation.png';

import * as styles from './DeleteMemberModal.styles';

const DeleteMemberModal = ({
  isDeleteMemberModalOpen,
  setDeleteMemberModal,
  fetchCompanyUsers,
  selectedMember,
}) => {
  const { companyId } = useParams();
  const { setNotification, setNotificationContent } = useContext(NotificationContext);

  const handleChangeStatus = async () => {
    try {
      const { data } = await api.deleteCompanyUser(companyId, selectedMember.id);
      if (data.code === 200) {
        await fetchCompanyUsers(companyId);
        setNotification(true);
        setNotificationContent({ type: 'success', message: data.message });
      }
    } catch (error) {
      setNotification(true);
      setNotificationContent({ type: 'error', message: error.response.message });
    } finally {
      setDeleteMemberModal(false);
    }
  };

  return (
    <Modal
      styles={styles.modalStyles}
      isModalOpen={isDeleteMemberModalOpen}
      setModal={setDeleteMemberModal}
    >
      <div css={styles.containerStyles}>
        <img css={styles.imageStyles} src={confirmationImage} alt="confirmation" />
        <ShortText styles={styles.titleStyles}>delete account</ShortText>
        <ShortText styles={styles.descriptionStyles}>
          are you sure to delete your account member?
        </ShortText>
        <div css={styles.buttonContainerStyles}>
          <Button className="cancel" type="button" styles={styles.buttonStyles}>
            cancel
          </Button>
          <Button type="button" onClick={handleChangeStatus} styles={styles.buttonStyles}>
            yes, continue
          </Button>
        </div>
      </div>
    </Modal>
  );
};

DeleteMemberModal.propTypes = {
  isDeleteMemberModalOpen: PropTypes.bool.isRequired,
  setDeleteMemberModal: PropTypes.func.isRequired,
  fetchCompanyUsers: PropTypes.func.isRequired,
  selectedMember: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    email: PropTypes.string,
    role: PropTypes.string,
    status: PropTypes.string,
  }).isRequired,
};

export default DeleteMemberModal;
